import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl, imageUrl } from "../Baseurl";

import pay1 from "../component/img/pay1.png";

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orderData = location.state;

  const {
    user_id,
    shipping_address_id,
    coupon,
    discount = 0,
    note: initialNote = "",
  } = orderData || {};

  const [selectedAddressId, setSelectedAddressId] = useState(shipping_address_id || null);
  const [note, setNote] = useState(initialNote);
  const [cartItems, setCartItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("Online");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const appliedCoupon = coupon || null;

  const fetchCartItemsWithCharges = async (userId, addressId) => {
    try {
      const res = await axios.get(`${baseurl}GetCartWithDeliveryCharges/${userId}/${addressId}`);
      if (res.data && Array.isArray(res.data.cartItems)) {
        setCartItems(res.data.cartItems);
      } else {
        Swal.fire("Error", "Failed to fetch cart items with delivery charges", "error");
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
      Swal.fire("Error", "Something went wrong while fetching cart data.", "error");
    }
  };

  useEffect(() => {
    if (selectedAddressId && user_id) {
      fetchCartItemsWithCharges(user_id, selectedAddressId);
    }
  }, [selectedAddressId]);

  const subtotal = cartItems.reduce((acc, item) => acc + item.total_with_delivery, 0);
  const totalDeliveryCharges = cartItems.reduce((acc, item) => acc + item.delivery_charge, 0);

  const grandTotal = subtotal - discount;

  const subnettotal = subtotal - totalDeliveryCharges ;

  const handlePlaceOrder = async () => {
    if (!selectedAddressId) {
      Swal.fire("Error", "Please select a shipping address.", "warning");
      return;
    }

    setIsSubmitting(true);

    const orderPayload = {
      user_id,
      shipping_address_id: selectedAddressId,
      coupon_id: coupon || 'null',
      discount,
      note,
      cartItems:cartItems,
      payment_method: paymentMethod,
      grand_total: grandTotal,
    };


    console.log("orderPayload", orderPayload);
    try {
      const response = await axios.post(`${baseurl}placeOrder`, orderPayload);
      if (response.data.success) {
        Swal.fire("Success", "Order placed successfully!", "success").then(() => {
          navigate("/my-orders");  
        });
      } else {
        Swal.fire("Error", response.data.message || "Failed to place order", "error");
      }
    } catch (error) {
      console.error("Order error:", error);
      Swal.fire("Error", "Something went wrong while placing the order.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };


  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };



  return (
    <>
      <VisitorNavbar />
      <div className="container py-3">
        <h4 className="hesd mb-4 text-start">Checkout</h4>
        <div className="row">
          {/* Billing & Shipping Info */}
          <div className="col-md-8">
            <div className="card p-3 mb-3">
              {/* <h5 className="smry text-start">Checkout Summary</h5> */}
              {cartItems.map((item, index) => (
                <div key={index} className="row">
                    <div className="col-md-2">
                        <img src={`${imageUrl}listing/${item.image}`} className="cart-item-img me-3 img-fluid"/>
                    </div>
                    <div className="col-md-10">
                    <h5 className="mb-1 ttl90 text-start">
                            {item.title}
                          </h5>
<div className="text-start kajs">
    <div className=" "><span>Price: </span><span> {convertPrice(item.price)}  × {item.quantity} Qty</span></div> 
    <div><span>Gst: </span><span>{convertPrice(item.gst_amount)} × {item.quantity} Qty</span></div> 
    <div><span>Total: </span><span>{convertPrice(item.price_with_gst)}</span></div> 
</div>
             
                    </div>
                    
                  
                  
                  
                  <hr />
                </div>
              ))}

<div className="mt-4 text-start">
  <label className="form-label mb-3 fw-semibold fs-5">Select Payment Method</label>

  <div className="payment-method-option border rounded p-3 mb-3 d-flex align-items-center justify-content-between shadow-sm"
       style={{ cursor: 'pointer', backgroundColor: paymentMethod === "COD" ? '#f0f8ff' : '#fff' }}
       onClick={() => setPaymentMethod("COD")}>
    <div className="d-flex align-items-center">
      <input
        className="form-check-input me-3"
        type="radio"
        name="paymentMethod"
        id="cod"
        value="COD"
        checked={paymentMethod === "COD"}
        onChange={(e) => setPaymentMethod(e.target.value)}
      />
      <label className="form-check-label" htmlFor="cod" style={{ cursor: 'pointer' }}>
        <strong>Cash on Delivery (COD)</strong>
      </label>
    </div>
    <span className="badge bg-secondary">Pay on Arrival</span>
  </div>

  <div className="payment-method-option border rounded p-3 d-flex align-items-center justify-content-between shadow-sm"
       style={{ cursor: 'pointer', backgroundColor: paymentMethod === "Online" ? '#f0f8ff' : '#fff' }}
       onClick={() => setPaymentMethod("Online")}>
    <div className="d-flex align-items-center">
      <input
        className="form-check-input me-3"
        type="radio"
        name="paymentMethod"
        id="online"
        value="Online"
        checked={paymentMethod === "Online"}
        onChange={(e) => setPaymentMethod(e.target.value)}
      />
      <label className="form-check-label" htmlFor="online" style={{ cursor: 'pointer' }}>
        <strong>Online Payment</strong>
      </label>
    </div>
    <img src={pay1} alt="Online Payment" className="img-fluid ms-3" style={{ maxHeight: "40px" }} />
  </div>
</div>





            </div>
          </div>

          {/* Price Summary */}
          <div className="col-md-4">
            <div className="card p-3">
              <h5 className="smry text-start">Cart Summary</h5>

              <div className="d-flex justify-content-between">
                <div>Subtotal:</div>
                <div>{convertPrice(subnettotal.toFixed(2))} </div>
              </div>

              <div className="d-flex justify-content-between">
  <div>Delivery charges:</div>
  <div>{convertPrice(totalDeliveryCharges.toFixed(2))}</div>
</div>


              {appliedCoupon && (
                <div className="d-flex justify-content-between">
                  <div>Coupon ({appliedCoupon.coupon_code}):</div>
                  <div className="text-success">- {convertPrice(discount.toFixed(2))}</div>
                </div>
              )}

              <hr />

              <div className="d-flex justify-content-between grndttl mt-2">
                <div><b>Grand Total:</b></div>
                <div><strong>{convertPrice(grandTotal.toFixed(2))}</strong></div>
              </div>

            

              {/* <button
                className="btn btn-primary w-100 mt-3"
                onClick={handlePlaceOrder}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Placing Order..." : "Place Order"}
              </button> */}




              <button
  className="btn btn-primary w-100 mt-3"
  // onClick={() => {
  //   if (paymentMethod === "Online") {
  //     navigate("/payment-gateway", {
  //       state: {
  //         user_id,
  //         shipping_address_id: selectedAddressId,
  //         coupon,
  //         discount,
  //         note,
  //         cartItems,
  //         payment_method: paymentMethod,
  //         grand_total: grandTotal,
  //       },
  //     });
  //   } else {
  //     handlePlaceOrder();
  //   }
  // }}



  onClick={() => {
  if (paymentMethod === "Online") {
    const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";

    navigate(
      selectedCurrency === "USD"
        ? "/payment-gateway-paypal"
        : "/payment-gateway",
      {
        state: {
          user_id,
          shipping_address_id: selectedAddressId,
          coupon,
          discount,
          note,
          cartItems,
          payment_method: paymentMethod,
          grand_total: grandTotal,
        },
      }
    );
  } else {
    handlePlaceOrder();
  }
}}



  disabled={isSubmitting}
>
  {isSubmitting ? "Processing..." : "Place Order"}
</button>






            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentPage;
